/** Master story/project jobs for the Tasks → Stories tab (must match backend STORY_MASTER_JOB_TYPES). */
import { IMAGE_STORY_JOB_TYPE } from '@/lib/imageStoryGenerationJob';

export const STORY_MASTER_JOB_TYPES = new Set([
  'story',
  'narration_pipeline',
  'script_based_pipeline',
  'song_based_pipeline',
  'narration_full_automation',
  'news_video_pipeline',
  'learning_tutorial',
  'learning_tutorial_render',
  'pitch_recording_pipeline',
  'mascot_animation_pipeline',
  'reels_shorts_pipeline',
  'reels_shorts_render',
  'script_audio_align_pipeline',
  'avatar_cast_pipeline',
]);

export const TASK_STATUS_FILTERS = [
  { id: '', label: 'All statuses' },
  { id: 'active', label: 'Active' },
  { id: 'pending', label: 'Pending' },
  { id: 'running', label: 'Running' },
  { id: 'completed', label: 'Completed' },
  { id: 'failed', label: 'Failed' },
  { id: 'cancelled', label: 'Cancelled' },
];

/** Job types shown in the Tasks page type filter (labels supplied by the page). */
export const TASK_TYPE_FILTER_OPTIONS = [
  { id: '', label: 'All types' },
  { id: 'story', label: 'Story Generation' },
  { id: 'export', label: 'Video Export' },
  { id: 'narration_pipeline', label: 'Narration Video' },
  { id: 'script_based_pipeline', label: 'Script-based' },
  { id: 'song_based_pipeline', label: 'Song-based' },
  { id: 'narration_full_automation', label: 'Narration (full automation)' },
  { id: 'news_video_pipeline', label: 'News Video' },
  { id: 'learning_tutorial', label: 'Learning tutorial' },
  { id: 'learning_tutorial_render', label: 'Learning tutorial export' },
  { id: 'script_audio_align_pipeline', label: 'Tutorial / presentation' },
  { id: 'avatar_cast_pipeline', label: 'AvatarCast' },
  { id: 'pitch_recording_pipeline', label: 'Pitch recording' },
  { id: 'mascot_animation_pipeline', label: 'News mascot animation' },
  { id: 'reels_shorts_pipeline', label: 'REEL&SHORTS' },
  { id: 'reels_shorts_render', label: 'REEL&SHORTS final video' },
  { id: 'video', label: 'Video Generation' },
  { id: 'audio', label: 'Audio Narration' },
  { id: 'music', label: 'Background Music' },
  { id: 'pdf', label: 'PDF Export' },
  { id: 'image_regen', label: 'Image Regeneration' },
  { id: IMAGE_STORY_JOB_TYPE, label: 'Image storyboard' },
  { id: 'ad', label: 'Ad Generation' },
];

export const STORY_TASK_TYPE_FILTER_OPTIONS = TASK_TYPE_FILTER_OPTIONS.filter(
  (opt) => !opt.id || STORY_MASTER_JOB_TYPES.has(opt.id),
);

/** Open in agent is shown for every story-master Task History row. */
export function canOpenJobInAgent(job) {
  return STORY_MASTER_JOB_TYPES.has(job?.job_type);
}

/**
 * Client-side guard so snippet jobs (segment video, extend frame, etc.) never render on Stories.
 * @param {Array<Record<string, unknown>>} jobs
 * @param {'all' | 'stories'} scope
 */
export function filterJobsForTaskScope(jobs, scope) {
  const list = Array.isArray(jobs) ? jobs : [];
  if (scope !== 'stories') return list;
  return list.filter((job) => STORY_MASTER_JOB_TYPES.has(job?.job_type));
}
